import React, {PureComponent, ReactNode} from 'react';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {type ArtifactLike} from 'app/utils/artifactToLoot';

interface Props extends Omit<ArtifactLike, 'image'> {
    image?: ArtifactLike['image'] | {url: string | null};
    langs?: {[key: string]: string | null};
    total_inventory_items?: number;
}

export default class PopupImage extends PureComponent<Props> {
    render(): ReactNode {
        return <PrizeCard
            artifact={this.props as ArtifactLike}
            hideMeta
            hideName
            quantity={this.props.total_inventory_items}
            showQuantityOrange
        />;
    }
}
